import { Component, Element, Event, EventEmitter, h, Prop } from '@stencil/core';

@Component({
  tag: 'pnk-radio-button',
  styleUrl: 'pnk-radio-button.css',
})
export class PnkRadioButton {
  @Element() host!: HTMLElement;

  randomName: string = `${Math.floor(Math.random() * 1000)}`;

  @Prop({ mutable: true }) name: string = `radio-button-${this.randomName}`;

  @Prop({ mutable: true }) value: string | undefined = undefined;

  @Prop({ mutable: true }) checked: boolean = false;

  @Prop() disabled: boolean = false;

  @Event() changed!: EventEmitter<boolean>;

  handleChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.checked = target.checked;
    this.changed.emit(this.checked);
  }

  render() {
    const spanStyle = {
      'pnk-appearance-none pnk-w-6 pnk-h-6  pnk-bg-disabled-base  pnk-rounded-full pnk-cursor-pointer ': !this.disabled && !this.checked,
      'pnk-appearance-none pnk-w-6 pnk-h-6  pnk-bg-disabled-base  pnk-rounded-full  pnk-opacity-50 ': this.disabled && !this.checked,
      'pnk-appearance-none pnk-w-6 pnk-h-6  pnk-bg-accent pnk-border-4 pnk-rounded-full pnk-cursor-pointer  ': !this.disabled && this.checked,
      'pnk-appearance-none pnk-w-6 pnk-h-6  pnk-opacity-50 pnk-bg-accent pnk-border-4  pnk-rounded-full ': this.disabled && this.checked,
    };

    return (
      <div class="pnk-flex pnk-flex-row pnk-items-center ">
        <input type="radio" class={spanStyle} name={this.name} onChange={event => this.handleChange(event)} disabled={this.disabled} checked={this.checked} value={this.value} />
        <span>
          <slot />
        </span>
      </div>
    );
  }
}
